import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';

import LoginForm from '../../containers/Login/LoginForm';
import { loginRequest, openForgotPasswordRequest } from '../../redux/modules/auth/auth-middleware';
import Message from '../../containers/Message/Message';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';
import { retrieveMessage } from '../../redux/modules/system-shared/message-bar-action-creator';


class LoginPage extends Component {
  constructor(props, context) {
    super(props, context);
    const parsedQueryString = QueryString.parse(this.props.location.search);
    let redirectTo = '/';
    if (parsedQueryString.redirect) {
      redirectTo = parsedQueryString.redirect + '?isAutoRedirect=true';
      Object.keys(parsedQueryString).forEach((param) => {
        if (param !== 'redirect') {
          const value = parsedQueryString[param];
          redirectTo += '&' + param + '=' + value;
        }
      });
    }

    this.state = {
      redirectTo,
    };
  }

  UNSAFE_componentWillMount = () => {
    const { dispatch } = this.props;
    dispatch(retrieveMessage());
    dispatch(setIsDedicatedWorkflow(false));
  }

  handleLogin = (creds) => {
    this.props.dispatch(loginRequest(creds, this.state.redirectTo));
  };
  handleForgotPassword = () => {
    openForgotPasswordRequest();
  }

  render() {
    return (
      <div className="col">
        <Message />
        <div className="content">
          <div>
            <LoginForm handleLogin={this.handleLogin} handleForgotPassword={this.handleForgotPassword} />
          </div>
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  location: ownProps.location,
});

export default connect(mapStateToProps)(LoginPage);